import Text from '@eversports/react-components/primitives/Text'
import React, { Fragment } from 'react'
import FormatDate from '@eversports/react-components/primitives/FormatDate'

import { Localized } from '../../localization/react'
import Availability, { AvailabilityPeriod, Weekday } from '../../typings/Availability'

interface TimePeriod {
  start: string
  end: string
}

const weekdayPeriodsReducer = (weekday: Weekday) => (timePeriods: Array<TimePeriod>, period: AvailabilityPeriod) => {
  if (period.weekdays.some((periodWeekday) => periodWeekday === weekday)) {
    timePeriods.push({ start: period.start, end: period.end })
  }

  return timePeriods
}

const getWeekdayPeriods = (availability: Availability) => {
  const weekdayPeriods = Object.keys(Weekday).map((weekdayPeriod) => ({
    weekday: weekdayPeriod,
    periods: availability.periods.reduce(weekdayPeriodsReducer(weekdayPeriod as Weekday), []),
  }))

  return weekdayPeriods
}

interface Props {
  availabilities: Array<Availability>
}

const CardAvailabilitiesInformation: React.FC<React.PropsWithChildren<Props>> = ({ availabilities }) => (
  <div>
    <Text size="small" color="subtleText">
      <Localized id="time-restrictions" />
    </Text>
    {availabilities.map((availability) => {
      const weekdayPeriods = getWeekdayPeriods(availability)

      return (
        <Fragment key={`${availability.start}/${availability.end}`}>
          <Text marginBottom="dense">
            <Localized
              id="monthly-availability-period"
              params={{
                startDay: <FormatDate value={availability.start} variant="long" />,
                endDay: <FormatDate value={availability.end} variant="long" />,
              }}
            />
          </Text>
          {weekdayPeriods.map((weekdayPeriod) => (
            <Text key={weekdayPeriod.weekday}>
              <Localized
                id="weekday-periods"
                params={{
                  weekday: <Localized id="weekday" params={{ day: weekdayPeriod.weekday }} />,
                  periods:
                    weekdayPeriod.periods.length > 0
                      ? weekdayPeriod.periods.map((period) => `${period.start}-${period.end}`).join(', ')
                      : '-',
                }}
              />
            </Text>
          ))}
        </Fragment>
      )
    })}
  </div>
)

export default CardAvailabilitiesInformation
